import { SKU_MAPPING } from '@constants/schemaConstants'

const cheerio = typeof window === 'undefined' ? global.cheerio : window.cheerio

export const getHeadingDesc = (content, fullDescription = false) => {
  const result = {
    heading: '',
    description: '',
  }
  if (!cheerio || typeof content !== 'string') return result

  const $ = cheerio.load(content, null, false)

  // Iterate through all heading tags (h1–h6)
  const headingHtml = $('h1, h2, h3, h4, h5, h6').first()

  if (headingHtml.length) {
    // If a heading exists, extract its text
    result.heading = $(headingHtml).text().trim()

    if (fullDescription) {
      // Get everything after the heading
      const descriptionParts: string[] = []
      $(headingHtml)
        .nextAll()
        .each((_, el) => {
          descriptionParts.push($(el).text())
        })
      result.description = descriptionParts.join(' ').trim()
    } else {
      // Only get the next paragraph
      const nextP = $(headingHtml).nextAll('p').first()
      if (nextP.length) {
        result.description = nextP.text().trim()
      }
    }
  } else {
    const descriptionParts: string[] = []
    // No heading found — use the whole content as description
    $('p').each((_, el) => {
      descriptionParts.push($(el).text())
    })
    result.description = descriptionParts.join(' ').trim()
  }

  return result
}

export const generateImageSchema = (url?: string | null, alt?: string, urlAttribute = 'contentUrl') => {
  const imageUrl = url?.trim()
  if (!imageUrl || imageUrl.toLowerCase().startsWith('data:')) return null
  const fileName = imageUrl.split('/').pop()?.split(/[?#]/)[0]?.split('.')[0]
  if (!fileName) {
    return {
      '@context': 'https://schema.org',
      '@type': 'ImageObject',
      [urlAttribute]: imageUrl,
      name: imageUrl,
      description: alt ?? imageUrl,
    }
  }
  const cleaned = fileName
    .replace(/[_-]+/g, ' ') // Replace underscores/hyphens
    .replace(/\b(webp|jpg|jpeg|png)\b/gi, '') // Remove format words
    .replace(/[_-]?[a-f0-9]{6,}$/i, '') // Remove hash-like suffix
    .trim()
    .replace(/\s+/g, ' ')
    .replace(/\b\w/g, c => c.toUpperCase()) // Capitalize words

  return {
    '@context': 'https://schema.org',
    '@type': 'ImageObject',
    [urlAttribute]: imageUrl,
    name: cleaned,
    description: alt ?? cleaned,
  }
}

export function resolveSKU(category = '', subCategory = '') {
  const text = `${category} ${subCategory}`.toLowerCase()

  const match = SKU_MAPPING.find(map => map.keywords.some(k => text.includes(k)))

  return match ? match.value : null
}
